import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { noop } from 'Helpers/PropTypes';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';

const styles = theme => ({
  root: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.facet.backgroundGray,
    borderRadius: theme.radius.md,
    whiteSpace: 'nowrap',
  },
  button: {
    padding: theme.spacing(0.5, 2),
    width: 64,
    '&:first-child': {
      marginRight: theme.spacing(1),
    },
  },
});

const Switch = ({
  className,
  classes,
  onChange,
  leftText,
  rightText,
  selected,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <RoundedButton
        className={classes.button}
        color={selected ? 'primary' : 'primaryGray'}
        variant={selected ? 'contained' : 'outlined'}
        onClick={onChange}
        padding={'dense'}
        test={`${leftText.toLowerCase()}-button`}
      >
        {leftText}
      </RoundedButton>
      <RoundedButton
        className={classes.button}
        color={selected === false ? 'primary' : 'primaryGray'}
        variant={selected === false ? 'contained' : 'outlined'}
        onClick={onChange}
        padding={'dense'}
        test={`${rightText.toLowerCase()}-button`}
      >
        {rightText}
      </RoundedButton>
    </div>
  );
};

Switch.defaultProps = {
  className: '',
  onChange: noop,
  leftText: 'Yes',
  rightText: 'No',
  selected: false,
};

Switch.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  leftText: PropTypes.string,
  rightText: PropTypes.string,
  selected: PropTypes.bool,
};

export default withStyles(styles)(Switch);
